(function () {

  var SECOND_LOGO_FEE = 7.50; // ex-GST, per cap
  var GST_RATE        = 0.10;

  var CAP_PRICES = {
    '6277 Worn By The World – Fitted':        { tier1: 40.00, tier2: 25.00 },
    '6277ADJ Worn By The World – Adjustable': { tier1: 40.00, tier2: 25.00 },
    '6277MT Worn By The World – Trucker':     { tier1: 40.00, tier2: 25.00 },
    '6277 Worn By The World – Jumbo':         { tier1: 40.00, tier2: 25.00 },
    'Flexfit 110A':                                { tier1: 45.00, tier2: 30.00 },
    'Flexfit 110A Air':                            { tier1: 45.00, tier2: 30.00 },
    'Flexfit 110WW Workwear':                      { tier1: 45.00, tier2: 30.00 },
    'Flexfit 110CD Cool & Dry':                    { tier1: 45.00, tier2: 30.00 },
    'Flexfit 110DAD Dad Cap':                      { tier1: 45.00, tier2: 30.00 },
    'Flexfit 110MT Trucker':                       { tier1: 45.00, tier2: 30.00 },
    'Flexfit 110P Cool & Dry':                     { tier1: 45.00, tier2: 30.00 },
    'Flexfit 110F Snapback':                       { tier1: 45.00, tier2: 30.00 },
    'Flexfit Delta 180 Fitted':                    { tier1: 45.00, tier2: 30.00 },
    'Flexfit Delta 180A Adjustable':               { tier1: 45.00, tier2: 30.00 },
    'Flexfit 5006 Worn By The World Bucket Hat':   { tier1: 45.00, tier2: 30.00 },
    'Flexfit 5006CD Cool & Dry Bucket Hat':        { tier1: 45.00, tier2: 30.00 },
    'Flexfit 6572 Cool & Dry':                     { tier1: 40.00, tier2: 25.00 },
    'Flexfit 6511 Mesh Trucker':                   { tier1: 40.00, tier2: 25.00 },
    'Flexfit 6213 Mini Ottoman':                   { tier1: 40.00, tier2: 25.00 },
    'Flexfit 6597 Cool & Dry Sports':              { tier1: 40.00, tier2: 25.00 },
    'Flexfit 6560 Hexa 5 Panel':                   { tier1: 40.00, tier2: 25.00 },
    'YP Classics 6507 Striped Trucker':                    { tier1: 35.00, tier2: 20.00 },
    'YP Classics 6507A A-Frame':                          { tier1: 35.00, tier2: 20.00 },
    'YP Classic 6606 Retro Trucker':                      { tier1: 35.00, tier2: 20.00 },
    'YP Classic 6606T Classic Retro Wade Trucker':        { tier1: 35.00, tier2: 20.00 },
    'YP Classic 6006 Classic Universal Trucker':          { tier1: 35.00, tier2: 20.00 },
    'YP Classic 6245CM Low Profile Cotton Twill Dad Hat': { tier1: 35.00, tier2: 20.00 },
    'YP Classic 6506 Trucker 5 Panel':                    { tier1: 35.00, tier2: 20.00 },
    'YP Classic 6320 Hi Crown Trucker':                   { tier1: 35.00, tier2: 20.00 },
    'YP Classic 6505 Country Stitch':                     { tier1: 35.00, tier2: 20.00 },
    'YP Classics 6007 Classic 5 Panel':                   { tier1: 35.00, tier2: 20.00 }
  };

  var FIXED_BACK_MODELS = [
    '6277 Worn By The World – Fitted',
    'Flexfit 6572 Cool & Dry',
    '6277 Worn By The World – Jumbo'
  ];

  var CAP_COLOURS = {
    '6277 Worn By The World – Fitted': [
      'Baby Pink', 'Black', 'Black/Black (Black Underpeak)', 'Light Beige', 'Brown', 'Charcoal',
      'Dark Grey', 'Dark Navy', 'Fresh Green', 'Grey', 'Khaki', 'Maroon', 'Navy', 'NSW Blue',
      'Olive', 'Orange', 'Pink', 'Purple', 'Red', 'Royal', 'Silver', 'Spruce', 'White', 'Yellow'
    ],
    '6277ADJ Worn By The World – Adjustable': ['Black', 'Navy', 'Dark Grey'],
    '6277MT Worn By The World – Trucker':     ['Black', 'Navy'],
    '6277 Worn By The World – Jumbo':         ['Black', 'Black/Black (Black Underpeak)', 'Dark Navy', 'Navy'],
    'Flexfit 110A':                           ['Black', 'Charcoal', 'Khaki', 'Maroon', 'Navy'],
    'Flexfit 110A Air':                       ['Black', 'Charcoal', 'Khaki', 'Navy'],
    'Flexfit 110WW Workwear':                 ['Black', 'Khaki', 'Moss Green', 'Navy'],
    'Flexfit 110CD Cool & Dry':               ['Black', 'Khaki', 'Navy', 'Olive'],
    'Flexfit 6572 Cool & Dry':                ['Black', 'Khaki', 'Navy', 'Olive'],
    'YP Classics 6507 Striped Trucker': [
      'Black/White', 'Evergreen/White', 'Royal/Black', 'Maroon/White', 'Red/White',
      'Brown/Khaki', 'Navy/White', 'Pink/Black', 'Steel Blue/Silver', 'Khaki/Black',
      'Charcoal/Black', 'Black/Black', 'Navy/Navy'
    ],
    'YP Classics 6507A A-Frame':                          ['Black', 'Charcoal', 'Khaki', 'Navy'],
    'YP Classic 6606 Retro Trucker': [
      'Army Olive', 'Black', 'Caramel', 'Charcoal', 'Evergreen', 'Khaki',
      'Maroon', 'Navy', 'Pink', 'Silver', 'White'
    ],
    'Flexfit 110DAD Dad Cap':                             ['Black', 'Navy'],
    'Flexfit 110MT Trucker':                              ['Navy/White', 'Melange Silver/White', 'Melange Charcoal/Black', 'Charcoal/White', 'Black/White'],
    'Flexfit 110P Cool & Dry':                            ['Black', 'Navy', 'Red', 'Royal', 'White'],
    'Flexfit 110F Snapback':                              ['Black'],
    'Flexfit Delta 180 Fitted':                           ['Black', 'Navy', 'Red'],
    'Flexfit Delta 180A Adjustable':                      ['Black', 'Navy', 'Silver'],
    'Flexfit 5006 Worn By The World Bucket Hat':          ['Black', 'Navy'],
    'Flexfit 5006CD Cool & Dry Bucket Hat':               ['Black', 'Navy', 'Khaki', 'Olive'],
    'Flexfit 6511 Mesh Trucker':                          ['Black', 'Navy', 'Charcoal', 'White'],
    'Flexfit 6213 Mini Ottoman':                          ['Black', 'Navy', 'Steel Grey'],
    'Flexfit 6597 Cool & Dry Sports':                     ['Black', 'Navy', 'Grey'],
    'Flexfit 6560 Hexa 5 Panel':                          ['Black', 'Navy', 'Khaki'],
    'YP Classic 6606T Classic Retro Wade Trucker': [
      'Black/White', 'Brown/Khaki', 'Brown/Black', 'Caramel/Black', 'Charcoal/Black',
      'Charcoal/Navy', 'Charcoal/Neon Green', 'Charcoal/Neon Orange', 'Charcoal/White',
      'Evergreen/White', 'Heather Grey/Black', 'Heather Grey/White', 'Maroon/Grey',
      'Moss Green/Khaki', 'Navy/Silver', 'Navy/White', 'Red/Black', 'Red/White',
      'Royal/White', 'Rust Orange/Khaki', 'Steel Blue/Silver', 'Teal/White',
      'Army Olive/Black', 'Khaki/Black'
    ],
    'YP Classic 6006 Classic Universal Trucker':          ['Black', 'Red', 'Navy', 'Charcoal'],
    'YP Classic 6245CM Low Profile Cotton Twill Dad Hat': ['Black', 'Navy', 'Khaki', 'Light Blue', 'Baby Pink', 'Cranberry', 'Orange', 'Spruce', 'White'],
    'YP Classic 6506 Trucker 5 Panel':                    ['Black', 'Navy', 'Charcoal', 'Red', 'Khaki', 'White', 'Maroon'],
    'YP Classic 6320 Hi Crown Trucker':                   ['Black', 'Navy'],
    'YP Classic 6505 Country Stitch':                     ['Black Denim/Khaki', 'Navy Denim/Khaki', 'Red Denim/Khaki'],
    'YP Classics 6007 Classic 5 Panel':                   ['Black', 'Navy', 'Grey', 'Charcoal', 'Royal', 'White']
  };

  var CAP_SIZES = {
    '6277 Worn By The World – Fitted':        [{ size: 'S/M',    name: 'S/M',    range: '54–58cm' }, { size: 'L/XL',   name: 'L/XL',   range: '57–61cm' }],
    '6277ADJ Worn By The World – Adjustable': [{ size: 'S/M', name: 'S/M', range: '54–58cm' }, { size: 'L/XL', name: 'L/XL', range: '57–61cm' }],
    '6277MT Worn By The World – Trucker':     [{ size: 'S/M', name: 'S/M', range: '54–58cm' }, { size: 'L/XL', name: 'L/XL', range: '57–61cm' }],
    '6277 Worn By The World – Jumbo':         [{ size: 'L/XXXL', name: 'L/XXXL', range: '59–64cm' }],
    'Flexfit 110A':                           [{ size: 'OSFA',   name: 'OSFA',   range: '52–63cm' }],
    'Flexfit 110A Air':                       [{ size: 'OSFA',   name: 'OSFA',   range: '52–63cm' }],
    'Flexfit 110WW Workwear':                 [{ size: 'OSFA',   name: 'OSFA',   range: '52–63cm' }],
    'Flexfit 110CD Cool & Dry':               [{ size: 'OSFA', name: 'OSFA', range: '52–63cm' }],
    'Flexfit 110DAD Dad Cap':                 [{ size: 'OSFA', name: 'OSFA', range: '52–63cm' }],
    'Flexfit 110MT Trucker':                  [{ size: 'OSFA', name: 'OSFA', range: '52–63cm' }],
    'Flexfit 110P Cool & Dry':                [{ size: 'OSFA', name: 'OSFA', range: '52–63cm' }],
    'Flexfit 110F Snapback':                  [{ size: 'OSFA', name: 'OSFA', range: '52–63cm' }],
    'Flexfit Delta 180 Fitted':               [{ size: 'S/M', name: 'S/M', range: '54–58cm' }, { size: 'L/XL', name: 'L/XL', range: '57–61cm' }],
    'Flexfit Delta 180A Adjustable':          [{ size: 'S/M', name: 'S/M', range: '54–58cm' }, { size: 'L/XL', name: 'L/XL', range: '57–61cm' }],
    'Flexfit 5006 Worn By The World Bucket Hat': [{ size: 'S/M', name: 'S/M', range: '54–58cm' }, { size: 'L/XL', name: 'L/XL', range: '57–61cm' }],
    'Flexfit 5006CD Cool & Dry Bucket Hat':      [{ size: 'S/M', name: 'S/M', range: '54–58cm' }, { size: 'L/XL', name: 'L/XL', range: '57–61cm' }],
    'Flexfit 6572 Cool & Dry':                [{ size: 'S/M', name: 'S/M', range: '54–58cm' }, { size: 'L/XL', name: 'L/XL', range: '57–61cm' }],
    'Flexfit 6511 Mesh Trucker':              [{ size: 'S/M', name: 'S/M', range: '54–58cm' }, { size: 'L/XL', name: 'L/XL', range: '57–61cm' }],
    'Flexfit 6213 Mini Ottoman':              [{ size: 'S/M', name: 'S/M', range: '54–58cm' }, { size: 'L/XL', name: 'L/XL', range: '57–61cm' }],
    'Flexfit 6597 Cool & Dry Sports':         [{ size: 'S/M', name: 'S/M', range: '54–58cm' }, { size: 'L/XL', name: 'L/XL', range: '57–61cm' }],
    'Flexfit 6560 Hexa 5 Panel':              [{ size: 'S/M', name: 'S/M', range: '54–58cm' }, { size: 'L/XL', name: 'L/XL', range: '57–61cm' }],
    'YP Classics 6507 Striped Trucker':                    [{ size: 'OSFA', name: 'OSFA', range: '53–61cm' }],
    'YP Classics 6507A A-Frame':                          [{ size: 'OSFA', name: 'OSFA', range: '53–61cm' }],
    'YP Classic 6606 Retro Trucker':                      [{ size: 'OSFA', name: 'OSFA', range: '53–61cm' }],
    'YP Classic 6606T Classic Retro Wade Trucker':        [{ size: 'OSFA', name: 'OSFA', range: '53–61cm' }],
    'YP Classic 6006 Classic Universal Trucker':          [{ size: 'OSFA', name: 'OSFA', range: '53–61cm' }],
    'YP Classic 6245CM Low Profile Cotton Twill Dad Hat': [{ size: 'OSFA', name: 'OSFA', range: '53–61cm' }],
    'YP Classic 6506 Trucker 5 Panel':                    [{ size: 'OSFA', name: 'OSFA', range: '53–61cm' }],
    'YP Classic 6320 Hi Crown Trucker':                   [{ size: 'OSFA', name: 'OSFA', range: '53–61cm' }],
    'YP Classic 6505 Country Stitch':                     [{ size: 'OSFA', name: 'OSFA', range: '53–61cm' }],
    'YP Classics 6007 Classic 5 Panel':                   [{ size: 'OSFA', name: 'OSFA', range: '53–61cm' }]
  };

  function formatMoney(value) {
    return '$' + value.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  var cof = {
    currentStep:   1,
    totalSteps:    7,
    _sectionCount: 0,

    el: {
      steps:       null,
      progSteps:   null,
      prevBtn:     null,
      nextBtn:     null,
      stepNum:     null,
      section:     null,
      success:     null,
      submitError: null,
      shopifyForm: null
    },

    data: {
      capTier:       '',
      capStyles:     [],
      decoration:    '',
      positions:     [],
      capColour:     '',
      totalQty:      0,
      firstName:     '',
      lastName:      '',
      business:      '',
      email:         '',
      logoFilename:  '',
      logoUrl:       '',
      logoUploading: false
    },

    init: function () {
      var section = document.getElementById('custom-order-form');
      if (!section) return;

      this.el.section     = section;
      this.el.steps       = section.querySelectorAll('.cof-step');
      this.el.progSteps   = section.querySelectorAll('.cof-progress__step');
      this.el.prevBtn     = document.getElementById('cof-prev');
      this.el.nextBtn     = document.getElementById('cof-next');
      this.el.stepNum     = document.getElementById('cof-step-num');
      this.el.success     = document.getElementById('cof-success');
      this.el.submitError = document.getElementById('cof-submit-error');
      this.el.shopifyForm = document.getElementById('cof-shopify-form');

      // Check if returning from a successful Shopify contact form submission
      if (window.location.search.indexOf('submitted=1') !== -1) {
        var storedName  = sessionStorage.getItem('cof_first_name') || '';
        var storedEmail = sessionStorage.getItem('cof_email') || '';
        sessionStorage.removeItem('cof_first_name');
        sessionStorage.removeItem('cof_email');
        // history.replaceState intentionally removed so ?submitted=1 stays in URL for Meta pixel tracking
        document.querySelector('.cof-layout').hidden = true;
        document.querySelector('.cof-nav').hidden     = true;
        document.querySelector('.cof-header').hidden  = true;
        this.el.success.hidden = false;
        this.el.success.querySelector('.cof-success__name').textContent  = storedName;
        this.el.success.querySelector('.cof-success__email').textContent = storedEmail;
        this.el.success.scrollIntoView({ behavior: 'smooth', block: 'center' });
        if (window.oaiq) oaiq("measure", "lead_created", { type: "customer_action", amount: 0, currency: "AUD" });
        if (window.fbq) fbq('track', 'Lead');
        return;
      }

      this.bindNav();
      this.bindPositionCheckboxes();
      this.bindQtyInputs();
      this.bindFileUpload();
      this.bindSummaryListeners();
      this.bindReset();

      // Global handler: click outside any colour picker panel closes it
      document.addEventListener('click', function (e) {
        if (!e.target.closest || !e.target.closest('.cof-colour-picker')) {
          document.querySelectorAll('.cof-colour-picker__panel').forEach(function (p) { p.hidden = true; });
        }
      });
    },

    // ── Navigation ──────────────────────────────────────────────────────────

    bindNav: function () {
      var self = this;
      this.el.prevBtn.addEventListener('click', function () { self.goTo(self.currentStep - 1); });
      this.el.nextBtn.addEventListener('click', function () {
        if (self.currentStep === self.totalSteps) {
          self.submit();
        } else if (self.validate(self.currentStep)) {
          self.goTo(self.currentStep + 1);
        }
      });
    },

    goTo: function (step) {
      this.el.steps[this.currentStep - 1].classList.remove('is-active');
      this.el.progSteps[this.currentStep - 1].classList.remove('is-active');
      this.el.progSteps[this.currentStep - 1].classList.add('is-done');

      if (step < this.currentStep) {
        this.el.progSteps[this.currentStep - 1].classList.remove('is-done');
      }

      this.currentStep = step;
      this.el.steps[step - 1].classList.add('is-active');
      this.el.progSteps[step - 1].classList.add('is-active');
      this.el.progSteps[step - 1].classList.remove('is-done');

      this.el.prevBtn.disabled       = (step === 1);
      this.el.nextBtn.textContent    = (step === this.totalSteps) ? 'Place Order' : 'Next →';
      this.el.stepNum.textContent    = step;

      if (step === 2) this.filterCapsByTier();
      if (step === 4) this.updatePositionOptions();
      if (step === 5) this.syncModelSections();

      this.el.section.scrollIntoView({ behavior: 'smooth', block: 'start' });
    },

    // ── Validation ───────────────────────────────────────────────────────────

    validate: function (step) {
      var stepEl  = this.el.steps[step - 1];
      var errorEl = stepEl.querySelector('.cof-error');
      var valid   = true;

      if (errorEl) errorEl.hidden = true;

      if (step === 1) {
        valid = !!stepEl.querySelector('input[name="cap_tier"]:checked');
      } else if (step === 2) {
        valid = document.querySelectorAll('input[name="cap_style"]:checked').length > 0;
      } else if (step === 3) {
        valid = !!stepEl.querySelector('input[name="decoration"]:checked');
      } else if (step === 4) {
        valid = stepEl.querySelectorAll('.cof-pos-checkbox:checked').length > 0;
      } else if (step === 5) {
        var hasColour = document.querySelectorAll('.cof-colour-checkbox:checked').length > 0;
        var hasQty    = this.data.totalQty >= 25;
        valid = hasColour && hasQty;
        if (!valid && errorEl) {
          errorEl.textContent = !hasColour
            ? 'Please select at least one colour for each model.'
            : 'Minimum order is 25 caps total — please add more quantities.';
          errorEl.hidden = false;
          return false;
        }
      } else if (step === 6) {
        valid = this.validateDetails();
      }

      if (!valid && errorEl) errorEl.hidden = false;
      return valid;
    },

    validateDetails: function () {
      var fields = [
        document.getElementById('cof-first-name'),
        document.getElementById('cof-last-name'),
        document.getElementById('cof-business'),
        document.getElementById('cof-email'),
        document.getElementById('cof-phone'),
        document.getElementById('cof-address'),
        document.getElementById('cof-suburb'),
        document.getElementById('cof-state'),
        document.getElementById('cof-postcode')
      ];
      var allFilled = fields.every(function (f) { return f && f.value.trim() !== ''; });
      var emailValid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(document.getElementById('cof-email').value.trim());
      return allFilled && emailValid;
    },

    // ── Logo position — max 2 ────────────────────────────────────────────────

    bindPositionCheckboxes: function () {
      var self = this;
      var checkboxes = document.querySelectorAll('.cof-pos-checkbox');
      var feeNotice  = document.querySelector('.cof-second-logo-fee');

      checkboxes.forEach(function (cb) {
        cb.addEventListener('change', function () {
          var checked = document.querySelectorAll('.cof-pos-checkbox:checked');
          if (checked.length > 2) { cb.checked = false; return; }

          checkboxes.forEach(function (c) {
            if (!c.checked) c.disabled = checked.length >= 2;
          });
          if (feeNotice) feeNotice.hidden = checked.length < 2;

          self.data.positions = Array.from(document.querySelectorAll('.cof-pos-checkbox:checked')).map(function (c) { return c.value; });
          self.updateSummary();
          self.updatePriceCalc();
        });
      });
    },

    updatePositionOptions: function () {
      var checkedStyles  = Array.from(document.querySelectorAll('input[name="cap_style"]:checked')).map(function (c) { return c.value; });
      var centrBackInput = document.querySelector('input.cof-pos-checkbox[value="Centre Back"]');
      var adjBackInput   = document.querySelector('input.cof-pos-checkbox[value="Adjustable Centre Back"]');
      if (!centrBackInput || !adjBackInput) return;

      var centrBackLabel = centrBackInput.closest ? centrBackInput.closest('label') : centrBackInput.parentElement;
      var adjBackLabel   = adjBackInput.closest   ? adjBackInput.closest('label')   : adjBackInput.parentElement;

      // Reset both to enabled/visible
      centrBackInput.disabled = false;
      adjBackInput.disabled   = false;
      if (centrBackLabel) centrBackLabel.hidden = false;
      if (adjBackLabel)   adjBackLabel.hidden   = false;

      if (checkedStyles.length > 0) {
        var allFixed  = checkedStyles.every(function (s) { return FIXED_BACK_MODELS.indexOf(s) !== -1; });
        var noneFixed = checkedStyles.every(function (s) { return FIXED_BACK_MODELS.indexOf(s) === -1; });

        if (allFixed) {
          if (adjBackLabel) adjBackLabel.hidden = true;
          adjBackInput.checked  = false;
          adjBackInput.disabled = true;
        } else if (noneFixed) {
          if (centrBackLabel) centrBackLabel.hidden = true;
          centrBackInput.checked  = false;
          centrBackInput.disabled = true;
        }
        // Mixed fixed + adjustable: show all options
      }

      // Re-apply 2-max disabled state
      var checkedCount = document.querySelectorAll('.cof-pos-checkbox:checked').length;
      document.querySelectorAll('.cof-pos-checkbox').forEach(function (c) {
        if (!c.disabled) c.disabled = !c.checked && checkedCount >= 2;
      });

      var feeNotice = document.querySelector('.cof-second-logo-fee');
      if (feeNotice) feeNotice.hidden = checkedCount < 2;

      this.data.positions = Array.from(document.querySelectorAll('.cof-pos-checkbox:checked')).map(function (c) { return c.value; });
      this.updateSummary();
      this.updatePriceCalc();
    },

    filterCapsByTier: function () {
      var tier    = document.querySelector('input[name="cap_tier"]:checked');
      var tierVal = tier ? tier.value : null;

      document.querySelectorAll('.cof-tier-group').forEach(function (group) {
        group.hidden = (group.dataset.tier !== tierVal);
      });

      // Deselect any checked caps that belong to a different tier
      document.querySelectorAll('input[name="cap_style"]:checked').forEach(function (cb) {
        var capGroup = cb.closest ? cb.closest('.cof-tier-group') : null;
        if (capGroup && capGroup.dataset.tier !== tierVal) {
          cb.checked = false;
        }
      });

      this.updateSummary();
      this.updatePriceCalc();
    },

    // ── Quantity total ───────────────────────────────────────────────────────

    bindQtyInputs: function () {
      var self  = this;
      var step5 = document.querySelector('[data-step="5"]');
      if (!step5) return;
      ['input', 'change'].forEach(function (evt) {
        step5.addEventListener(evt, function (e) {
          if (e.target.classList.contains('cof-qty-input')) self.calcQty();
        });
      });
    },

    calcQty: function () {
      var total = 0;
      document.querySelectorAll('.cof-qty-input').forEach(function (input) {
        total += Math.max(0, parseInt(input.value, 10) || 0);
      });
      this.data.totalQty = total;

      var totalEl = document.querySelector('.cof-qty-total-value');
      var warnEl  = document.querySelector('.cof-moq--warn');
      var okEl    = document.querySelector('.cof-moq--ok');
      var bulkEl  = document.querySelector('.cof-moq--bulk');

      if (totalEl) totalEl.textContent = total;
      if (warnEl)  warnEl.hidden  = !(total > 0 && total < 25);
      if (okEl) {
        var needed = 50 - total;
        okEl.textContent = '— add ' + needed + ' more cap' + (needed === 1 ? '' : 's') + ' to unlock bulk pricing';
        okEl.hidden = !(total >= 25 && total < 50);
      }
      if (bulkEl)  bulkEl.hidden  = !(total >= 50);

      this.updateSummary();
      this.updatePriceCalc();
      this.updateMatrixTotals();
    },

    // ── Multi-model colour picker + matrix ───────────────────────────────────

    syncModelSections: function () {
      var self           = this;
      var selectedModels = Array.from(document.querySelectorAll('input[name="cap_style"]:checked')).map(function (c) { return c.value; });
      var container      = document.getElementById('cof-model-sections');
      if (!container) return;

      // Remove sections for deselected models
      Array.from(container.children).forEach(function (section) {
        if (selectedModels.indexOf(section.dataset.model) === -1) {
          container.removeChild(section);
        }
      });

      // Add sections for newly selected models (preserving order)
      selectedModels.forEach(function (model) {
        var existing = null;
        Array.from(container.children).forEach(function (section) {
          if (section.dataset.model === model) existing = section;
        });
        if (!existing) {
          container.appendChild(self.createModelSection(model));
        }
      });
    },

    createModelSection: function (model) {
      var self    = this;
      var idx     = ++this._sectionCount;
      var colours = CAP_COLOURS[model] || [];

      var section = document.createElement('div');
      section.className    = 'cof-model-section';
      section.dataset.model = model;

      var colourHTML = colours.map(function (colour, i) {
        var cbId = 'clr-' + idx + '-' + i;
        return '<label class="cof-checkbox-card" for="' + cbId + '">' +
          '<input type="checkbox" id="' + cbId + '" name="cap_colour" value="' + colour.replace(/"/g, '&quot;') + '" class="cof-colour-checkbox" data-model="' + model.replace(/"/g, '&quot;') + '">' +
          '<span class="cof-checkbox-card__label">' + colour + '</span>' +
          '</label>';
      }).join('');

      section.innerHTML =
        '<h4 class="cof-model-section__title">' + model + '</h4>' +
        '<div class="cof-field">' +
          '<label class="cof-label">Cap colour(s) <span class="cof-required">*</span></label>' +
          '<p class="cof-hint">Choose your colours — each gets its own row in the quantity grid.</p>' +
          '<div class="cof-colour-picker">' +
            '<button type="button" class="cof-colour-picker__btn"' + (colours.length === 0 ? ' disabled' : '') + '>' +
              '<span class="cof-colour-picker__label">' + (colours.length === 0 ? 'No colours available' : 'Select colours...') + '</span>' +
              '<span class="cof-colour-picker__arrow" aria-hidden="true">▾</span>' +
            '</button>' +
            '<div class="cof-colour-picker__panel" hidden>' +
              '<div class="cof-colour-picker__options">' + colourHTML + '</div>' +
            '</div>' +
          '</div>' +
        '</div>' +
        '<div class="cof-field cof-model-matrix-wrap" hidden>' +
          '<label class="cof-label">Quantities by colour &amp; size</label>' +
          '<div class="cof-matrix"></div>' +
        '</div>';

      this.bindModelSection(section, model);
      return section;
    },

    bindModelSection: function (section, model) {
      var self  = this;
      var btn   = section.querySelector('.cof-colour-picker__btn');
      var panel = section.querySelector('.cof-colour-picker__panel');
      var opts  = section.querySelector('.cof-colour-picker__options');
      if (!btn || !panel || !opts) return;

      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        // Close any other open panels
        document.querySelectorAll('.cof-colour-picker__panel').forEach(function (p) {
          if (p !== panel) p.hidden = true;
        });
        panel.hidden = !panel.hidden;
      });

      opts.addEventListener('change', function (e) {
        if (!e.target.classList.contains('cof-colour-checkbox')) return;
        var colour = e.target.value;
        if (e.target.checked) {
          self.addColourRow(section, model, colour);
        } else {
          self.removeColourRow(section, model, colour);
        }
        // Update this section's picker label
        var labelEl = section.querySelector('.cof-colour-picker__label');
        if (labelEl) {
          var checked = Array.from(section.querySelectorAll('.cof-colour-checkbox:checked'));
          if (!checked.length) {
            labelEl.textContent = 'Select colours...';
          } else if (checked.length === 1) {
            labelEl.textContent = checked[0].value;
          } else {
            labelEl.textContent = checked.length + ' colours selected';
          }
        }
        self.updateSummary();
      });
    },

    buildMatrixShellInSection: function (section, model) {
      var matrixEl = section.querySelector('.cof-matrix');
      var sizes    = CAP_SIZES[model] || [];
      if (!matrixEl || !sizes.length) return;

      var html = '<table class="cof-matrix-table"><thead><tr>';
      html += '<th class="cof-matrix-th cof-matrix-th--colour">Colour</th>';
      sizes.forEach(function (s) {
        html += '<th class="cof-matrix-th">' + s.name + '<br><span class="cof-size-range">(' + s.range + ')</span></th>';
      });
      html += '<th class="cof-matrix-th">Total</th></tr></thead>';
      html += '<tbody></tbody>';
      html += '<tfoot><tr><td class="cof-matrix-foot-label">Model total</td>';
      sizes.forEach(function (s) {
        html += '<td class="cof-matrix-col-total" data-size="' + s.size + '">0</td>';
      });
      html += '<td class="cof-matrix-grand-total">0</td></tr></tfoot></table>';
      matrixEl.innerHTML = html;
    },

    addColourRow: function (section, model, colour) {
      var self  = this;
      var sizes = CAP_SIZES[model] || [];
      if (!sizes.length) return;

      var table = section.querySelector('.cof-matrix-table');
      if (!table) {
        this.buildMatrixShellInSection(section, model);
        table = section.querySelector('.cof-matrix-table');
      }
      if (!table) return;

      var tbody = table.querySelector('tbody');
      if (!tbody) return;

      // Prevent duplicate rows
      var rows = tbody.querySelectorAll('tr[data-colour]');
      for (var i = 0; i < rows.length; i++) {
        if (rows[i].dataset.colour === colour) return;
      }

      var tr = document.createElement('tr');
      tr.dataset.colour = colour;

      var colourTd = document.createElement('td');
      colourTd.className   = 'cof-matrix-colour';
      colourTd.textContent = colour;
      tr.appendChild(colourTd);

      sizes.forEach(function (s) {
        var td    = document.createElement('td');
        td.className = 'cof-matrix-cell';
        var input = document.createElement('input');
        input.type           = 'number';
        input.className      = 'cof-size-input cof-qty-input';
        input.dataset.colour = colour;
        input.dataset.size   = s.size;
        input.min   = '0';
        input.value = '0';
        input.setAttribute('aria-label', colour + ' ' + s.size);
        input.addEventListener('input',  function () { self.calcQty(); });
        input.addEventListener('change', function () { self.calcQty(); });
        td.appendChild(input);
        tr.appendChild(td);
      });

      var totalTd = document.createElement('td');
      totalTd.className      = 'cof-matrix-row-total';
      totalTd.dataset.colour = colour;
      totalTd.textContent    = '0';
      tr.appendChild(totalTd);

      tbody.appendChild(tr);

      var wrap = section.querySelector('.cof-model-matrix-wrap');
      if (wrap) wrap.hidden = false;
    },

    removeColourRow: function (section, model, colour) {
      var table = section.querySelector('.cof-matrix-table');
      if (!table) return;
      var tbody = table.querySelector('tbody');
      if (!tbody) return;

      var rows = tbody.querySelectorAll('tr[data-colour]');
      for (var i = 0; i < rows.length; i++) {
        if (rows[i].dataset.colour === colour) {
          tbody.removeChild(rows[i]);
          break;
        }
      }

      if (!tbody.querySelector('tr')) {
        var wrap = section.querySelector('.cof-model-matrix-wrap');
        if (wrap) wrap.hidden = true;
      }
      this.calcQty();
    },

    updateMatrixTotals: function () {
      document.querySelectorAll('.cof-matrix-table').forEach(function (table) {
        // Row totals
        table.querySelectorAll('tbody tr[data-colour]').forEach(function (row) {
          var rowTotal = 0;
          row.querySelectorAll('.cof-qty-input').forEach(function (inp) {
            rowTotal += Math.max(0, parseInt(inp.value, 10) || 0);
          });
          var colour     = row.dataset.colour;
          var rowTotalEl = table.querySelector('.cof-matrix-row-total[data-colour="' + colour + '"]');
          if (rowTotalEl) rowTotalEl.textContent = rowTotal;
        });

        // Column totals (per size, within this model's table)
        table.querySelectorAll('.cof-matrix-col-total').forEach(function (cell) {
          var colTotal = 0;
          table.querySelectorAll('.cof-qty-input[data-size="' + cell.dataset.size + '"]').forEach(function (inp) {
            colTotal += Math.max(0, parseInt(inp.value, 10) || 0);
          });
          cell.textContent = colTotal;
        });

        // Grand total for this model's table only
        var modelTotal = 0;
        table.querySelectorAll('.cof-qty-input').forEach(function (inp) {
          modelTotal += Math.max(0, parseInt(inp.value, 10) || 0);
        });
        var grandEl = table.querySelector('.cof-matrix-grand-total');
        if (grandEl) grandEl.textContent = modelTotal;
      });
    },

    // ── Price calculator ─────────────────────────────────────────────────────

    updatePriceCalc: function () {
      var pricingBlock = document.getElementById('sum-pricing');
      var unitPriceEl  = document.getElementById('sum-unit-price');
      var logoFeeRow   = document.getElementById('sum-logo-fee-row');
      var subtotalEl   = document.getElementById('sum-subtotal');
      var savingRow    = document.getElementById('sum-saving-row');
      var savingEl     = document.getElementById('sum-saving');
      var gstEl        = document.getElementById('sum-gst');
      var totalEl      = document.getElementById('sum-total');
      var priceTierEl  = document.getElementById('sum-price-tier');

      var qty       = this.data.totalQty;
      var hasSecond = this.data.positions.length >= 2;
      var isBulk    = qty >= 50;

      if (!pricingBlock) return;

      var modelSections = document.querySelectorAll('.cof-model-section');

      if (modelSections.length === 0 || qty < 25) {
        pricingBlock.hidden = true;
        return;
      }

      var subtotal     = 0;
      var hasAnyPrices = false;
      var displayPrice = null; // all models in a tier share the same price

      modelSections.forEach(function (section) {
        var model  = section.dataset.model;
        var prices = CAP_PRICES[model];
        if (!prices) return;
        hasAnyPrices = true;

        var capPrice = isBulk ? prices.tier2 : prices.tier1;
        if (displayPrice === null) displayPrice = capPrice;

        var modelQty = 0;
        section.querySelectorAll('.cof-qty-input').forEach(function (inp) {
          modelQty += Math.max(0, parseInt(inp.value, 10) || 0);
        });
        if (modelQty === 0) return;

        subtotal += modelQty * capPrice;
      });

      if (!hasAnyPrices || subtotal === 0) {
        pricingBlock.hidden = true;
        return;
      }

      if (hasSecond) subtotal += qty * SECOND_LOGO_FEE;

      var gst   = subtotal * GST_RATE;
      var total = subtotal + gst;

      if (priceTierEl) priceTierEl.textContent = isBulk ? '50+ cap price' : '25–49 cap price';
      if (unitPriceEl && displayPrice !== null) unitPriceEl.textContent = formatMoney(displayPrice) + ' +GST';
      if (logoFeeRow)  logoFeeRow.hidden        = !hasSecond;
      if (subtotalEl)  subtotalEl.textContent   = formatMoney(subtotal);
      if (gstEl)       gstEl.textContent        = formatMoney(gst);
      if (totalEl)     totalEl.textContent      = formatMoney(total);

      // Bulk saving vs 25–49 pricing
      if (savingRow && savingEl) {
        if (isBulk && displayPrice !== null) {
          var tier1Subtotal = 0;
          modelSections.forEach(function (section) {
            var model  = section.dataset.model;
            var prices = CAP_PRICES[model];
            if (!prices) return;
            var modelQty = 0;
            section.querySelectorAll('.cof-qty-input').forEach(function (inp) {
              modelQty += Math.max(0, parseInt(inp.value, 10) || 0);
            });
            tier1Subtotal += modelQty * prices.tier1;
          });
          if (hasSecond) tier1Subtotal += qty * SECOND_LOGO_FEE;
          var tier1Total = tier1Subtotal * (1 + GST_RATE);
          savingEl.textContent = '−' + formatMoney(tier1Total - total) + ' inc-GST';
          savingRow.hidden     = false;
        } else {
          savingRow.hidden = true;
        }
      }

      pricingBlock.hidden = false;
    },

    // ── File upload ──────────────────────────────────────────────────────────

    bindFileUpload: function () {
      var self       = this;
      var area       = document.getElementById('cof-upload-area');
      var input      = document.getElementById('cof-file-input');
      var preview    = document.getElementById('cof-upload-preview');
      var filenameEl = document.getElementById('cof-upload-filename');
      var removeBtn  = document.getElementById('cof-upload-remove');

      if (!area || !input) return;

      area.addEventListener('click', function () { input.click(); });

      ['dragenter', 'dragover'].forEach(function (evt) {
        area.addEventListener(evt, function (e) { e.preventDefault(); area.classList.add('is-dragging'); });
      });
      ['dragleave', 'drop'].forEach(function (evt) {
        area.addEventListener(evt, function (e) { e.preventDefault(); area.classList.remove('is-dragging'); });
      });
      area.addEventListener('drop', function (e) {
        var file = e.dataTransfer.files[0];
        if (file) self.setFile(file, area, preview, filenameEl);
      });
      input.addEventListener('change', function () {
        if (input.files[0]) self.setFile(input.files[0], area, preview, filenameEl);
      });
      removeBtn && removeBtn.addEventListener('click', function () {
        input.value = '';
        self.data.logoFilename  = '';
        self.data.logoUrl       = '';
        self.data.logoUploading = false;
        area.hidden    = false;
        preview.hidden = true;
      });
    },

    setFile: function (file, area, preview, filenameEl) {
      if (file.size > 10 * 1024 * 1024) { alert('File is too large. Maximum size is 10MB.'); return; }
      this.data.logoFilename  = file.name;
      this.data.logoUrl       = '';
      this.data.logoUploading = true;
      if (filenameEl) filenameEl.textContent = file.name;
      if (area)    area.hidden    = true;
      if (preview) preview.hidden = false;

      var self     = this;
      var formData = new FormData();
      formData.append('file',          file);
      formData.append('upload_preset', 'flexfit-logos');

      fetch('https://api.cloudinary.com/v1_1/dznux2lls/raw/upload', {
        method: 'POST',
        body:   formData
      })
      .then(function (res) { return res.json(); })
      .then(function (data) {
        if (data.secure_url) {
          self.data.logoUrl = data.secure_url;
        } else {
          self.data.logoUrl = '';
          console.error('[COF] Cloudinary upload error:', data.error && data.error.message);
        }
        self.data.logoUploading = false;
      })
      .catch(function (err) {
        self.data.logoUrl       = '';
        self.data.logoUploading = false;
        console.error('[COF] Cloudinary fetch failed:', err);
      });
    },

    // ── Summary updates ───────────────────────────────────────────────────────

    bindSummaryListeners: function () {
      var self = this;
      document.querySelectorAll('input[name="cap_tier"]').forEach(function (r) {
        r.addEventListener('change', function () { self.data.capTier = r.value; });
      });
      document.querySelectorAll('input[name="cap_style"]').forEach(function (cb) {
        cb.addEventListener('change', function () {
          self.updateSummary();
          self.updatePriceCalc();
        });
      });
      document.querySelectorAll('input[name="decoration"]').forEach(function (r) {
        r.addEventListener('change', function () { self.updateSummary(); });
      });
    },

    updateSummary: function () {
      var styles    = Array.from(document.querySelectorAll('input[name="cap_style"]:checked')).map(function (c) { return c.value; });
      var deco      = document.querySelector('input[name="decoration"]:checked');
      var positions = Array.from(document.querySelectorAll('.cof-pos-checkbox:checked')).map(function (c) { return c.value; });
      var colours   = Array.from(document.querySelectorAll('.cof-colour-checkbox:checked')).map(function (c) { return c.value; });

      var styleEl   = document.getElementById('sum-style');
      var decoEl    = document.getElementById('sum-deco');
      var posEl     = document.getElementById('sum-positions');
      var colourEl  = document.getElementById('sum-colour');
      var qtyEl     = document.getElementById('sum-qty');
      var logoFeeEl = document.getElementById('sum-second-logo');

      if (styleEl) { styleEl.hidden = !styles.length; if (styles.length) document.getElementById('sum-style-val').textContent = styles.join(', '); }
      if (decoEl)  { decoEl.hidden  = !deco;  if (deco)  document.getElementById('sum-deco-val').textContent  = deco.value; }
      if (posEl)   { posEl.hidden   = !positions.length; if (positions.length) document.getElementById('sum-positions-val').textContent = positions.join(', '); }
      if (logoFeeEl) logoFeeEl.hidden = positions.length < 2;

      if (colourEl) {
        colourEl.hidden = !colours.length;
        if (colours.length) document.getElementById('sum-colour-val').textContent = colours.join(', ');
      }
      if (qtyEl) {
        qtyEl.hidden = this.data.totalQty === 0;
        if (this.data.totalQty) document.getElementById('sum-qty-val').textContent = this.data.totalQty + ' caps';
      }
    },

    // ── Reset ─────────────────────────────────────────────────────────────────

    bindReset: function () {
      var self = this;
      var btn  = document.getElementById('cof-reset');
      if (btn) btn.addEventListener('click', function () { self.resetForm(); });
    },

    resetForm: function () {
      document.querySelectorAll('input[name="cap_tier"]').forEach(function (r) { r.checked = false; });
      document.querySelectorAll('.cof-tier-group').forEach(function (g) { g.hidden = true; });
      document.querySelectorAll('input[name="cap_style"]').forEach(function (cb) { cb.checked = false; });
      document.querySelectorAll('input[name="decoration"]').forEach(function (r) { r.checked = false; });
      document.querySelectorAll('.cof-pos-checkbox').forEach(function (cb) { cb.checked = false; cb.disabled = false; });
      var feeNotice = document.querySelector('.cof-second-logo-fee');
      if (feeNotice) feeNotice.hidden = true;

      // Clear all model sections (colour pickers + matrices)
      var modelSections = document.getElementById('cof-model-sections');
      if (modelSections) modelSections.innerHTML = '';

      // Reset file upload
      var fileInput = document.getElementById('cof-file-input');
      if (fileInput) fileInput.value = '';
      var uploadArea    = document.getElementById('cof-upload-area');
      var uploadPreview = document.getElementById('cof-upload-preview');
      if (uploadArea)    uploadArea.hidden    = false;
      if (uploadPreview) uploadPreview.hidden = true;

      // Reset data
      this.data.capTier      = '';
      this.data.capStyles    = [];
      this.data.decoration   = '';
      this.data.positions    = [];
      this.data.capColour    = '';
      this.data.totalQty     = 0;
      this.data.logoFilename = '';
      this.data.logoUrl      = '';

      // Reset progress bar and steps
      this.el.steps.forEach(function (s, i) {
        s.classList.remove('is-active');
        if (i === 0) s.classList.add('is-active');
      });
      this.el.progSteps.forEach(function (s, i) {
        s.classList.remove('is-active', 'is-done');
        if (i === 0) s.classList.add('is-active');
      });

      this.currentStep            = 1;
      this.el.prevBtn.disabled    = true;
      this.el.nextBtn.textContent = 'Next →';
      this.el.stepNum.textContent = '1';

      document.querySelectorAll('.cof-error').forEach(function (e) { e.hidden = true; });

      this.updatePositionOptions();
      this.updateSummary();
      this.updatePriceCalc();
      this.calcQty();

      this.el.section.scrollIntoView({ behavior: 'smooth', block: 'start' });
    },

    // ── Compile order message ─────────────────────────────────────────────────

    compileMessage: function () {
      var self      = this;
      var styles    = Array.from(document.querySelectorAll('input[name="cap_style"]:checked')).map(function (c) { return c.value; });
      var deco      = document.querySelector('input[name="decoration"]:checked');
      var positions = Array.from(document.querySelectorAll('.cof-pos-checkbox:checked')).map(function (c) { return c.value; });
      var isBulk    = this.data.totalQty >= 50;
      var hasSecond = positions.length >= 2;

      var now     = new Date();
      var dateStr = ('0' + now.getDate()).slice(-2) + '/' + ('0' + (now.getMonth() + 1)).slice(-2) + '/' + now.getFullYear();

      var firstName = document.getElementById('cof-first-name').value.trim();
      var lastName  = document.getElementById('cof-last-name').value.trim();
      var business  = document.getElementById('cof-business').value.trim();
      var email     = document.getElementById('cof-email').value.trim();
      var phone     = document.getElementById('cof-phone').value.trim();
      var address   = document.getElementById('cof-address').value.trim();
      var suburb    = document.getElementById('cof-suburb').value.trim();
      var state     = document.getElementById('cof-state').value;
      var postcode  = document.getElementById('cof-postcode').value.trim();
      var abn       = document.getElementById('cof-abn').value.trim();
      var notes     = document.getElementById('cof-notes').value.trim();
      var fullAddress = address + ', ' + suburb + ' ' + state + ' ' + postcode;

      var SEP  = '============================================================';
      var DASH = '------------------------------------------------------------';

      var lines = [
        'FLEXFIT CUSTOM CAP ORDER',
        SEP,
        '',
        'Date:     ' + dateStr,
        'Name:     ' + firstName + ' ' + lastName,
        'Business: ' + business,
        'Address:  ' + fullAddress,
        'Email:    ' + email,
        'Phone:    ' + phone
      ];
      if (abn)   lines.push('ABN:      ' + abn);
      if (notes) { lines.push(''); lines.push('Notes:    ' + notes); }

      lines.push('');
      lines.push(DASH);
      lines.push('LOGO & DECORATION');
      lines.push(DASH);
      lines.push('Cap model(s): ' + (styles.length ? styles.join(', ') : '—'));
      lines.push('Decoration:   ' + (deco ? deco.value : '—'));
      lines.push('Position(s):  ' + (positions.length ? positions.join(', ') : '—'));
      lines.push('2nd logo?     ' + (hasSecond ? 'Yes (+$' + SECOND_LOGO_FEE.toFixed(2) + ' +GST per cap)' : 'No'));

      lines.push('');
      lines.push(SEP);
      lines.push('CAPS ORDERED (' + this.data.totalQty + ' caps total)');
      lines.push(SEP);

      var grandCalcSubtotal = 0;
      var modelPriceLines   = [];

      document.querySelectorAll('.cof-model-section').forEach(function (section) {
        var model  = section.dataset.model;
        var prices = CAP_PRICES[model];

        lines.push('');
        lines.push('MODEL: ' + model);
        lines.push(DASH);

        // Colour × size breakdown for this model
        var colourGroups = {};
        var colourOrder  = [];
        section.querySelectorAll('.cof-qty-input').forEach(function (input) {
          var qty = parseInt(input.value, 10) || 0;
          if (qty > 0) {
            var c = input.dataset.colour || '—';
            var s = input.dataset.size   || '—';
            if (!colourGroups[c]) { colourGroups[c] = {}; colourOrder.push(c); }
            colourGroups[c][s] = (colourGroups[c][s] || 0) + qty;
          }
        });

        var modelTotal = 0;
        colourOrder.forEach(function (colour, i) {
          lines.push('');
          lines.push('  COLOUR ' + (i + 1) + ' — ' + colour);
          var colourTotal = 0;
          Object.keys(colourGroups[colour]).forEach(function (size) {
            var qty = colourGroups[colour][size];
            lines.push('    ' + size + ': ' + qty);
            colourTotal += qty;
          });
          lines.push('  Subtotal: ' + colourTotal + ' caps');
          modelTotal += colourTotal;
        });

        if (!colourOrder.length) lines.push('  (No quantities entered)');

        lines.push('');
        lines.push('Model total: ' + modelTotal + ' caps');

        if (prices) {
          var capPrice      = isBulk ? prices.tier2 : prices.tier1;
          var modelSubtotal = modelTotal * capPrice;
          grandCalcSubtotal += modelSubtotal;
          modelPriceLines.push(model + ': ' + modelTotal + ' caps × ' + formatMoney(capPrice) + ' = ' + formatMoney(modelSubtotal) + ' +GST');
        }
      });

      lines.push('');
      lines.push(SEP);
      lines.push('TOTAL CAPS: ' + this.data.totalQty);
      lines.push(SEP);

      // FOR OFFICE USE ONLY
      lines.push('');
      lines.push(DASH);
      lines.push('FOR OFFICE USE ONLY');
      lines.push(DASH);
      lines.push('Price tier:   ' + (isBulk ? '50+ cap pricing' : '25–49 cap pricing'));
      modelPriceLines.forEach(function (l) { lines.push(l); });

      if (hasSecond) {
        var secondFeeTotal = self.data.totalQty * SECOND_LOGO_FEE;
        lines.push('2nd logo fee: ' + self.data.totalQty + ' caps × ' + formatMoney(SECOND_LOGO_FEE) + ' = ' + formatMoney(secondFeeTotal) + ' +GST');
        grandCalcSubtotal += secondFeeTotal;
      }

      var calcGst   = grandCalcSubtotal * GST_RATE;
      var calcTotal = grandCalcSubtotal + calcGst;

      lines.push('Subtotal:     ' + formatMoney(grandCalcSubtotal) + ' + GST');
      lines.push('GST (10%):    ' + formatMoney(calcGst));
      lines.push('Total:        ' + formatMoney(calcTotal) + ' inc. GST');

      lines.push('');
      if (this.data.logoUrl) {
        lines.push('Logo file:    ' + this.data.logoFilename);
        lines.push('Logo link:    ' + this.data.logoUrl);
      } else {
        lines.push('Logo file:    ' + (this.data.logoFilename || 'To be emailed separately'));
      }
      lines.push('');
      lines.push(DASH);
      lines.push('This order was submitted via the Custom Cap Order Form at flexfit.com.au.');
      lines.push(DASH);

      return lines.join('\n');
    },

    // ── Submit ────────────────────────────────────────────────────────────────

    submit: function () {
      var self = this;

      if (this.data.logoUploading) {
        this.el.nextBtn.disabled    = true;
        this.el.nextBtn.textContent = 'Uploading logo…';
        setTimeout(function () { self.submit(); }, 1500);
        return;
      }

      var firstName = document.getElementById('cof-first-name').value.trim();
      var lastName  = document.getElementById('cof-last-name').value.trim();
      var email     = document.getElementById('cof-email').value.trim();

      document.getElementById('cof-form-name').value  = firstName + ' ' + lastName;
      document.getElementById('cof-form-email').value = email;
      document.getElementById('cof-form-body').value  = this.compileMessage();

      sessionStorage.setItem('cof_first_name', firstName);
      sessionStorage.setItem('cof_email', email);

      this.el.nextBtn.disabled    = true;
      this.el.nextBtn.textContent = 'Placing order…';

      document.getElementById('cof-shopify-submit').click();
    },

    showSuccess: function (firstName, email) {
      document.querySelector('.cof-layout').hidden = true;
      document.querySelector('.cof-nav').hidden     = true;
      document.querySelector('.cof-header').hidden  = true;
      this.el.success.hidden = false;
      this.el.success.querySelector('.cof-success__name').textContent  = firstName;
      this.el.success.querySelector('.cof-success__email').textContent = email;
    },

    showSubmitError: function () {
      this.el.submitError.hidden  = false;
      this.el.nextBtn.disabled    = false;
      this.el.nextBtn.textContent = 'Place Order';
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { cof.init(); });
  } else {
    cof.init();
  }
})();
